import { Box, Typography, Avatar, Grid, useTheme } from "@mui/material";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";

export default function DigitalIDCard({

  data,
  school, colors, code, fontcolor,
  // primary = "#0c2d73",
  bgType = "yellow"   // "yellow" OR "white"

}) {

  const dottedYellow = `radial-gradient(rgba(255,255,255,0.35) 1px, transparent 1px),#f6b21a`;
  const items = Array.isArray(data) ? data : [];
  const theme = useTheme();
  return (
    <Box id="emp-id-cards-root">
      <Grid container spacing={2}>
        {items?.map((emp) => (

          <Box sx={{
            width: 330,
            height: 450,
            bgcolor: "white",
            display: "flex",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: "0 18px 40px rgba(0,0,0,0.25)",
            fontFamily: "Arial"
          }} key={emp.id}>

            {/* LEFT STRIP */}
            <Box sx={{
              width: '20%',
              bgcolor: colors[emp.id] || theme.palette.primary.main,
              color: fontcolor || "white",
              writingMode: "vertical-rl",
              textOrientation: "mixed",
              display: "flex",
              flexWrap: 'wrap',
              alignContent: 'center',
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 800,
              letterSpacing: 2
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.5 }}>
                {school.schoolName}
              </Typography>
              <Typography variant="caption" sx={{ display: "block", lineHeight: 1.2 }}>
                {[school.addressDTO.addressLine1, school.addressDTO.city, school.addressDTO.pincode, school.addressDTO.state].join(", ")}
                | Tel: {school.contactPhone}
              </Typography>
            </Box>

            {/* RIGHT CONTENT */}
            <Box sx={{
              flex: 1,
              position: "relative",
              background:
                bgType === "yellow" ? dottedYellow : "white",
              backgroundSize: "7px 7px"
            }}>

              {/* LOGO */}
              <Box sx={{
                position: "absolute",
                top: 10,
                width: "100%",
                textAlign: "center"
              }}>
                <img src={school?.logoUrl || null} height={80} alt="logo" />
              </Box>


              {/* PHOTO FRAME */}
              <Box sx={{
                position: "absolute",
                top: 96,
                width: "100%",
                display: "flex",
                justifyContent: "center"
              }}>

                <Box sx={{
                  border: `4px solid ${colors[emp.id] || theme.palette.primary.main}`,
                  padding: "6px",
                  background: "white"
                }}>

                  <img src={emp.photo || null}
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover"
                    }} />

                </Box>

              </Box>


              {/* NAME */}
              <Box sx={{
                position: "absolute",
                top: 230,
                width: "100%",
                textAlign: "center"
              }}>

                <Typography fontWeight={900} mt={2}>
                  {[emp.firstName, emp.lastName].join(" ")}
                </Typography>

                <Box sx={{
                  display: "inline-block",
                  background: "black",
                  color: "white",
                  fontSize: 12,
                  px: 1.5,
                  mt: 0.5
                }}>
                  {data.role}
                </Box>

              </Box>


              {/* INFO */}
              <Box sx={{
                position: "absolute",
                top: 260,
                left: 20,
                fontSize: 13
              }}>
                <Box mt={2} fontSize={10} textAlign="left">
                  <Typography variant="subtitle2"><b>ID</b> : {emp.employeeCode}</Typography>
                  <Typography variant="subtitle2"><b>Email</b> : {emp.email}</Typography>
                  <Typography variant="subtitle2"><b>Phone</b> : {emp.phone}</Typography>
                  {/* <Typography variant="subtitle2"><b>Blood</b> : {emp.blood}</Typography> */}

                </Box>
              </Box>


              {/* BARCODE */}
              <Box sx={{
                position: "absolute",
                bottom: 10,
                width: "100%",
                textAlign: "center"
              }}>
                <Box mt={2} fontSize={10} >
                  {code === 'QRCode' ? (
                    <QRCode value={[emp.id, emp.employeeCode].join("#")} size={80} />
                  ) : code === 'Barcode' ? (
                    <Barcode width={1} height={60} value={[emp.id, emp.employeeCode].join("#")}
                    // format="CODE128"
                    />
                  ) : null}
                </Box>
              </Box>


              {/* WEBSITE FOOTER */}
              {/* <Box sx={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                bgcolor: colors[emp.id] || theme.palette.primary.main,
                color: "white",
                textAlign: "center",
                py: 1,
                fontSize: 12
              }}>
                {data.website}
              </Box> */}

            </Box>

          </Box>
        ))}
      </Grid>
    </Box>
  )
}
